import { flow } from '@helo/utils'

import { RenderPipeline } from '../RenderPipeline'
import { type DescriptorOptions, descriptorOptions } from './Descriptor.options'
import { DescriptorInputParts, DescriptorOutputParts } from './Descriptor.parts'

export { descriptorOptions } from './Descriptor.options'
export type { DescriptorOptions } from './Descriptor.options'

export type DescriptorInput = DescriptorOptions

export type DescriptorOutput = {
  title: string | undefined
  subtitle: string | undefined
  description: string | undefined
}

const descriptorSetup = () =>
  RenderPipeline.createFeatureSetup<DescriptorInput, DescriptorOutput>(
    flow(
      DescriptorInputParts.setupInput(),
      DescriptorOutputParts.setDescriptor(),
    ),
  )

export const Descriptor = {
  options: descriptorOptions,
  setup: descriptorSetup,
}
